module.exports = __webpack_public_path__ + "static/icons/icon-add-5d31a4109ab67eca6cad770866014bae.svg";